export default __webpack_public_path__ + "static/media/093-basque-country.0aac33de.svg";